import type { AxiosResponse } from "axios";

import { AxiosInstance } from "api";

export const completeAppointment = (id: number): Promise<AxiosResponse> =>
  AxiosInstance.put(`appointments/${id}`, { state: "completed" });
